'use client';
import { Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { Drawer } from '../../../../components/modules/Drawer';
import { MODAL_CONNECTORS_ID } from '@/components/modules/InvestModal';
import { InstitutionsToConnectList } from '@/modules/Wallet/ui/ConnectInstitutionsModal/InstitutionsToConnectList';

export const ConnectInstitutionsModal = () => {
  const i18n = useT();

  return (
    <Drawer
      id={MODAL_CONNECTORS_ID}
      showIconButton={false}
      headerContent={
        <Text size="2xl">
          {i18n('screens.myWallet.drawers.connectorsBrokers.titleAlternative')}
        </Text>
      }
      closeButtonProps={{ top: '3.125rem' }}
      bodyProps={{ px: '2xl' }}
      headerProps={{
        pl: '3.4375rem',
        pr: '3rem',
        py: '2.8125rem',
      }}
    >
      <InstitutionsToConnectList />
    </Drawer>
  );
};
